/**
 * Why a Stripe install came back to the integration page (`?stripe_error=`),
 * and what the page says about it. Client-safe: the callback sends these
 * codes and the page shows the copy, so a new code can't ship without words.
 */
const RESTART_COPY =
  'The Stripe install expired or was started in another tab. Try again.'
const RETRY_COPY = "Stripe couldn't be connected. Try again."

export const STRIPE_CONNECT_ERROR_COPY = {
  provider_denied: 'Stripe did not grant access.',
  missing_code: "Stripe didn't finish the install. Try again.",
  // The common cause: a test-mode or sandbox install, whose code the live
  // platform key can't exchange (Brew offers the live install link only).
  token_exchange_failed:
    "Stripe couldn't finish connecting. Try again — Brew connects live Stripe accounts, not test-mode or sandbox installs.",
  provisioning_failed: RETRY_COPY,
  connection_persist_failed: RETRY_COPY,
  missing_state: RESTART_COPY,
  invalid_state: RESTART_COPY,
  expired_state: RESTART_COPY,
  context_mismatch: RESTART_COPY,
} as const satisfies Record<string, string>

export type StripeConnectErrorCode = keyof typeof STRIPE_CONNECT_ERROR_COPY

/** The page's words for a `stripe_error`, or null when there is none. */
export function describeStripeConnectError(code: string | null): string | null {
  if (!code) {
    return null
  }
  // Own keys only: `?stripe_error=__proto__` must not read Object.prototype.
  return Object.hasOwn(STRIPE_CONNECT_ERROR_COPY, code)
    ? STRIPE_CONNECT_ERROR_COPY[code as StripeConnectErrorCode]
    : RETRY_COPY
}
